import React from 'react';
import './sec1-myticket.css'
import pic14 from '../assets/pic14.png'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Circlenav from '../components/common/circlenav-header';
import pic16 from '../assets/pic16.png'
import pic18 from '../assets/pic18.png'
import pic20 from '../assets/pic20.png'
import { useNavigate } from 'react-router-dom';
const Sec1myticket = () => {



 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);


const [booking, setBooking] = useState(null);

useEffect(() => {
    const getBooking = async () => {
        const { data, error } = await supabase
            .from('bookings')
            .select(`
                booking_date,
                id,
                users ( user_name ),
                ticket ( name ),
                exbition_event ( mobile_header, time )
            `).order('id', { ascending: true })
            .limit(1); 

        if (!error) {
            setBooking(data[0]);
        } else {
            console.log(error);
        }
    };

    getBooking();
}, []);

    const navigate = useNavigate();

    return ( 
        <section className='myticket-sec'>
                <section className='row-my-ticket'>
                        <section className='left-title-container-my-ticket'>
                                <img src={pic14} alt='back'  onClick={() => navigate(-1)} ></img>
                                <h1 className='header-my-ticket'>{content?.[29]?.header}</h1>
                        </section>

                        <Circlenav icon={pic16} alt='print' />
                </section>

                <section className='part2-my-ticket-sec'>

                        <img className='img2-decoration-tickett' src={pic18} alt='decoration'></img>


                        <article className='ticket-card'>
                                <article className='information-ticket-part-1'>
                                        <article className='container-event-title'>
                                            <h3 className='ecent-ticket'>Event Ticket</h3>
                                            <h1 className='event-tile-text'>   {booking?.exbition_event?.mobile_header}</h1>
                                        </article>

                                        <article className='timing-container-ticket'>
                                            <h2 className='date-event'> {booking?.booking_date}</h2>
                                            <div className='line-ticket'></div>
                                            <h2 className='date-event'>{booking?.exbition_event?.time}</h2>
                                        </article>

                                        <article  className='container-event-title'>
                                                <h2 className='user-name'> {booking?.users?.user_name}</h2>
                                                <h2 className='ticket-id'>#{booking?.id}</h2>
                                        </article>
                                </article>

                                
                                <article className='part2-ticket'>
                                        <h1 className='tickettype'>  {booking?.ticket?.name}</h1>
                                        <img className='qr-code' src={pic20} alt='qr code'/>
                                </article>





                        </article>

                        <img className='img-decoration-tickett' src={pic18} alt='decoration'></img>

                </section>
        </section>
     );
}
 
export default Sec1myticket;